import * as React from 'react';

export interface WeddingPackageProps {
    id: number;
    title: string;
    startingPriceText: string;
    description: string;
    contentLink: string;
}

export interface PackagesProps {
    packages: WeddingPackageProps[];
    onClickPackageInquire: (pkg: WeddingPackageProps, idx: number) => void;
}

export default class Packages extends React.Component<PackagesProps> {
    constructor(props: PackagesProps) {
        super(props);
        this.handlePackageClick = this.handlePackageClick.bind(this);
    }

    render() {
        return (
            <div className='Packages'>
                {this.props.packages.map((pkg, idx) => {
                    return (
                        <div className='Packages--package-row' key={idx}>
                            <div className='Packages--row-header'>{pkg.title}</div>
                            <div className='Packages--row-subheader'>{pkg.startingPriceText}</div>
                            <div className='Packages--row-description'>
                                {pkg.description.split('\r\n').map((item, idx) => {
                                    return <p key={idx}>{item}</p>;
                                })}
                            </div>
                            <div className='Packages--row-cta'>
                                <button className='nx-button' onClick={() => this.handlePackageClick(pkg, idx)}>
                                    Inquire about Package
                                </button>
                                <a href={pkg.contentLink} target='_blank' className='nx-button nx-button--primary'>
                                    View Package
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    private handlePackageClick(pkg: WeddingPackageProps, idx: number) {
        this.props.onClickPackageInquire(pkg, idx);
    }
}
